import { render, staticRenderFns } from "./addGroup.vue?vue&type=template&id=151ab090"
import script from "./addGroup.vue?vue&type=script&lang=js"
export * from "./addGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports